let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7hLu6")).then(() => parcelRequire('iPgAq'));